export default __webpack_public_path__ + "static/media/hero-screenshot-1.40a097b5.png";